<style src="./ReportEmployeeSales.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content print-content scrollpage">
    <h1 class="title">Relatório de Vendas</h1>
    <h3 class="subtitle">Vendedor: {{ employeeName }}</h3>
    <h3 class="subtitle">
      Período Inicio: <input type="date" v-model.lazy="periodDate" />
    </h3>
    <h3 class="subtitle" v-if="!isFromApp">
      Período Final: <input type="date" v-model.lazy="periodDateEnd" />
    </h3>

    <div>
      <h4>Vendas Efetuadas</h4>
    </div>
    <table class="tableprint">
      <thead>
        <tr>
          <th>TIPO</th>
          <th>Placa/CPF</th>
          <th>Colaborador</th>
          <th>Estacionamento</th>
          <th>Código</th>
          <th>Data</th>
          <th>Hora</th>
          <th>Valor</th>
          <th>Minutos</th>
          <th>Origem</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="showSpinner">
          <td>
            <spinner size="large" message="Aguarde..."></spinner>
          </td>
        </tr>
        <tr
          v-for="(item, idx) in resultList"
          :key="idx"
          :class="{ unread: item.settled }"
        >
          <td>{{ item.planName }}</td>
          <td>{{ item.licencePlate }}</td>
          <td>{{ item.employeeName }}</td>
          <td>{{ item.parkName }}</td>
          <td>{{ item.creditCode }}</td>
          <td>{{ fillDate(item.startDate) }}</td>
          <td>{{ fillTime(item.startDate) }}</td>
          <td>{{ totalToCurrencyBR(item.settledAmountPaid) }}</td>
          <td>{{ item.totalMinutes }}</td>
          <td>{{ paymentTypeDic(item.paymentType) }}</td>
        </tr>
      </tbody>
    </table>

    <p class="sumaryTitle">Resumo de Vendas</p>
    <table class="sumary">
      <tbody>
        <tr>
          <td class="ticketName"></td>
          <td class="qt">Qt</td>
          <td class="qt">Tempo</td>
          <td class="total">Valor R$</td>
        </tr>
        <tr v-for="(item, idx) in totalSold" :key="idx">
          <td class="plan">{{ dictionary[idx] || formatUpperCase(idx) }}</td>
          <td class="value">
            {{ item.count }}
          </td>
          <td class="value">
            {{ formatTime(item.minutes) }}
          </td>
          <td class="value">
            {{ totalToCurrencyBR(item.ticketValue) }}
          </td>
        </tr>
      </tbody>
    </table>

    <p class="sumaryTitle">Resumo de Emissões</p>
    <table class="sumary">
      <tbody>
        <tr>
          <td class="ticketName"></td>
          <td class="qt">Qt</td>
          <td class="qt">Tempo</td>
          <td class="total">Valor R$</td>
        </tr>
        <tr v-for="(item, idx) in totalEmissions" :key="idx">
          <td class="plan">{{ dictionary[idx] || formatUpperCase(idx) }}</td>
          <td class="value">
            {{ item.count }}
          </td>
          <td class="value">
            {{ formatTime(item.minutes) }}
          </td>
          <td class="value">
            {{ totalToCurrencyBR(item.ticketValue) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Spinner from '../../components/Spinner';

export default {
  name: 'ReportEmployeeSales',
  components: { Spinner },
  data() {
    return {
      employeeName: '',
      periodDate: '',
      periodDateEnd: '',
      resultList: [],
      totalEmissions: {},
      totalSold: {},
      showSpinner: false,
      form: {
        employee: '',
      },
      isFromApp: true,
      dictionary: {
        'walletSales': 'VENDA CARTEIRA',
      },
    };
  },
  mounted() {
    const dt = this.$route.params.date;
    this.periodDate = dt;
    this.periodDateEnd = dt;
    this.isFromApp = !!this.$route.meta.isFromApp;
    this.filterReport();
  },
  watch: {
    periodDate() {
      this.filterReport();
    },
  },
  methods: {
    paymentTypeDic(value) {
      switch (value) {
        case 'credit':
          return 'Crédito';
        case 'debit':
          return 'Débito';
        case 'cash':
          return 'Dinheiro';
        case 'wallet':
          return 'Carteira';
        default:
          return 'Dinheiro';
      }
    },
    formatUpperCase(value) {
      return value.toUpperCase();
    },
    formatTime(value) {
      if(value === 0) {
        return '0h 0m';
      }
      if (value === null || value === undefined) {
        return '-';
      }
      const hours = Math.floor(value / 60);
      const minutes = value % 60;
      return `${hours}h ${minutes}m`;
    },
    reportDate(value) {
      return new Date(value + ' 05:00:00').toLocaleDateString('pt-BR');
    },
    fillDate(value) {
      return new Date(value).toLocaleDateString('pt-BR');
    },
    fillTime(value) {
      return new Date(value).toLocaleTimeString('pt-BR');
    },
    totalToCurrencyBR(value) {
      if (!value) {
        return '-';
      }
      // return (value / 100).toFixed(2).toString().replace('.', ',');
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    generateQuery() {
      const query = {
        ...this.form,
        employee: this.$route.params.userToken || '',
      };

      let startDate = new Date(this.periodDate + ' 05:00:00');
      startDate = new Date(startDate).setHours(0);
      startDate = new Date(startDate).setMinutes(0);
      startDate = new Date(startDate).setSeconds(0);

      let endDate = new Date(this.periodDateEnd + ' 05:00:00');
      endDate = new Date(endDate).setHours(23);
      endDate = new Date(endDate).setMinutes(59);
      endDate = new Date(endDate).setSeconds(59);

      query.startDate = new Date(startDate);
      query.endDate = new Date(endDate);
      query.isFromApp = this.isFromApp;
      query.includeReversion = false;

      return query;
    },
    async filterReport() {
      this.showSpinner = true;
      this.totalAmountPaid = null;
      
      if (this.isFromApp) {
        this.periodDateEnd = this.periodDate;
      }
      this.$router.replace({
        name: 'ReportEmployeeSales',
        params: {
          userToken: this.$route.params.userToken,
          date: this.periodDate,
        },
      });

      const query = this.generateQuery();
      const totals = {};
      try {
        const reports = await this.$store.dispatch('REPORTS/EmployeeSales', {
          query,
        });

        this.employeeName = reports.userName;
        const resultList = reports.sales.map(item => {
          const licencePlate = item.vehicle
            ? item.vehicle.licencePlate.toUpperCase()
            : item.cpf;
          // const licencePlate = item.vehicle
          //   ? item.vehicle.licencePlate.toUpperCase()
          //   : '';
          const cpf = item.cpf;
          const planName = item.tariffPlanName;
          const paymentType = item.paymentType;
          const amountPaid = item.amountPaid;
          const creditCode = item.creditCode;
          const settledAmountPaid = item.settledAmountPaid;
          const totalMinutes = item.totalMinutes;
          const settled = item.settled;
          const parkName = item.parks ? item.parks.parkName : '-';
          const notification = item.notification
            ? item.notification.notifyCode
            : '-';
          let employeeName = '';
          let startDate = '';
          if (!totals[planName]) {
            totals[planName] = 0;
          }
          totals[planName] += 1;

          employeeName = (item.employee && item.employee.fullName) || '-';
          startDate = item.paymentDate;

          return {
            planName,
            licencePlate,
            creditCode,
            amountPaid,
            settledAmountPaid,
            totalMinutes,
            employeeName,
            parkName,
            startDate,
            settled,
            notification,
            paymentType,
            cpf,
          };
        });
        this.totalEmissions = reports.totalEmissions;
        this.totalSold = reports.totalSold;
        this.resultList = resultList;
        resultList;
        this.showSpinner = false;
      } catch (error) {
        this.resultList = [];
        this.totalEmissions = {};
        this.totalSold = {};
        this.showSpinner = false;
      }
    },
  },
};
</script>
